import {
  Button,
  Card,
  Col,
  Flex,
  Row,
  Space,
  Table,
  Tag,
  Typography,
  Spin,
  Avatar,
  Tooltip,
} from "antd";
import React, { useState } from "react";
import Title from "antd/es/typography/Title";
import { DropboxOutlined } from "@ant-design/icons";

import { useEffect } from "react";
import {
  DeleteIcon,
  EditIcon,
  InfoButtonIcon,
} from "../../../../../../assets/svg";
import { colors } from "../../../../../../constants/colors";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { routes } from "../../../../../../constants";
import { baseRouteMaker } from "../../../../../../constants/routeConsts";
import Actions from "../../../../../../redux/actions";
import { dateObjToDispViewDate } from "../../../../../../utils/utils";
import PackageDeleteDialog from "./PackageDeleteDialog";
import { getPackagesAction } from "../../../../../../redux/services/packages/packagesServices";
import Spinner from "../../../../../common/spinner/Spinner";
import { useCallback } from "react";
import PackageSponsorshipFormDialog from "./PackageSponsorshipFormDialog";
import useDebounce from "../../../../../../hooks/useDebounce";
import { appConstConfig } from "../../../../../../constants/config/appConstConfig";
import { appConfig } from "../../../../../../constants/config/appConfig";
import useLocalStorage from "../../../../../../hooks/useLocalStorage";
import { checkSponsorshipAction } from "../../../../../../redux/services/common/commonServices";
import { getUserProfileAction } from "../../../../../../redux/services/auth/authServices";
import { UserOutlined } from "@ant-design/icons";
import "../OffersAndPackages.scss"

const PackageList = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  const { userSession, setUserSession } = useLocalStorage(
    appConfig.SESSION_USER_INFO
  );
  const { sponsorshipAvailability } = useSelector((state) => state?.common);
  const { loginDetails } = useSelector((state) => state?.auth);

  /* table dependencies */
  const [columns, setColumns] = useState([]);
  const { packages } = useSelector((state) => state.packages);
  const [searchValue] = useState("");
  const { debouncedValue: debouncedSearchValue } = useDebounce(
    searchValue,
    500
  );
  const [pagination, setPagination] = useState({
    pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
    pageSize: appConstConfig.DEFAULT_TABLE_PAGE_SIZE,
  });
  const paginationObj = {
    total: packages?.total,
    current: pagination?.pageNo,
    pageSize: pagination?.pageSize,
    onChange: (pageNo, pageSize) => setPagination({ pageNo, pageSize }),
    pageSizeOptions: appConstConfig.DEFAULT_PAGE_SIZE_OPTIONS_ARR,
    showSizeChanger: true,
  };
  /* table dependencies */

  /* dialog dependencies */
  const [openServiceDeleteDialog, setOpenServiceDeleteDialog] = useState(false);
  const [openSponsorshipDialog, setOpenSponsorshipDialog] = useState(false);
  /* dialog dependencies */

  useEffect(() => {
    userSession &&
      Object.keys(userSession).length !== 0 &&
      userSession !== null &&
      userSession !== undefined &&
      dispatch(getUserProfileAction(setUserSession)).then((apiRes) => {
        const dataToBeSent = {
          type: "package",
          state: apiRes?.organization_id?.address?.state?.name,
          city: apiRes?.organization_id?.address?.city?.name,
        };
        dispatch(checkSponsorshipAction(dataToBeSent, setLoading));
      });
  }, []);

  useEffect(() => {
    handleGetTableData();
  }, [pagination, debouncedSearchValue]);

  /* function definition to get table data */
  const handleGetTableData = () => {
    const dataToBeSent = {
      page: debouncedSearchValue !== "" ? 1 : pagination?.pageNo,
      limit: pagination?.pageSize,
      search: debouncedSearchValue,
    };
    dispatch(getPackagesAction(dataToBeSent, setLoading));
  };
  /* function definition to get table data */

  /* initial dependencies rendering */
  useEffect(() => {
    /* table column config */
    const tempTableColumns = [
      {
        title: t("Modules.Packages.packageNameLabel"),
        key: "packageName",
        render: (_, { banner }) => {
          return (
            <Flex gap="1rem" align="center">
              <Avatar src={banner} key={banner} icon={<UserOutlined />} />
              {`${_.title}`}
            </Flex>
          );
        },
      },
      {
        title: t("Modules.Packages.startDate"),
        dataIndex: "packageStartDate",
        key: "packageStartDate",
        render: (_, record) => (
          <p>{dateObjToDispViewDate(record?.packageStartDate, "ddmmyyyy")}</p>
        ),
      },
      {
        title: t("Modules.Packages.endDate"),
        dataIndex: "packageEndDate",
        key: "packageEndDate",
        render: (_, record) => (
          <p>{dateObjToDispViewDate(record?.packageEndDate, "ddmmyyyy")}</p>
        ),
      },
      {
        title: t("Modules.Packages.thSponsored"),
        key: "top_listing_enabled",
        dataIndex: "top_listing_enabled",
        render: (_, record) => (
          <>
            <Tag
              bordered={false}
              style={{
                background: record?.top_listing_enabled
                  ? colors.lightTeal
                  : colors.lightPinkishRed,
                color: record?.top_listing_enabled
                  ? colors.darkTeal
                  : colors.darkMaroon,
              }}
            >
              {record?.top_listing_enabled
                ? t("Modules.Packages.thSponsored")
                : t("Modules.Packages.regular")}
            </Tag>
          </>
        ),
      },
      {
        title: (
          <>
            <Flex gap="1rem" align="center" justify="center">
              <>{t("Modules.Packages.addSponsor")}</>
              {loginDetails?.organization_id?.current_plan_id?.code ===
                "FREE" && (
                <Tooltip
                  placement="topLeft"
                  title={t("CommonUtils.upgradeYourSubscription")}
                  color={colors.DarkMint}
                >
                  <Button type="text" shape="circle" size="small">
                    <Flex align="center" justify="center">
                      <InfoButtonIcon />
                    </Flex>
                  </Button>
                </Tooltip>
              )}
            </Flex>
          </>
        ),
        key: "purchase-organization-sponsorship",
        dataIndex: "purchase-organization-sponsorship",
        align: "center",
        render: (_, record) => (
          <>
            <Button
              type="primary"
              size="small"
              onClick={(e) => handleAddSponsorship(e, record)}
              disabled={
                !sponsorshipAvailability?.sposorship_available ||
                loginDetails?.organization_id?.current_plan_id?.code ===
                  "FREE" ||
                record?.top_listing_enabled
              }
            >
              {t("Modules.Packages.addSponsor")}
            </Button>
          </>
        ),
      },
      {
        title: t("Modules.AutoCredit.status"),
        key: "action",
        align: "center",
        render: (_, record) => {
          const getColorBasedOnStatus = (status) => {
            switch (status) {
              case true:
                return { background: colors.lightTeal, color: colors.darkTeal };
  
              case false:
                return {
                  background: colors.lightPinkishRed,
                  color: colors.darkMaroon,
                };
  
              default:
                break;
            }
          };
          return (
            <>
              <Tag
                bordered={false}
                style={{
                  ...getColorBasedOnStatus(record?.is_active),
                  textTransform: "capitalize",
                }}
              >
                {record?.is_active === true ? t("CommonUtils.active") : t("CommonUtils.inactive")}
              </Tag>
            </>
          );
        },
      },
      {
        title: t("Modules.Packages.action"),
        key: "action",
        align: "center",
        render: (_, record) => {
          return (
            <>
            {
              record?.is_active ?
              <Flex gap="small" justify="center">
                <Space size="middle">
                  <Button
                    type="text"
                    size="medium"
                    icon={<EditIcon fillColor={colors.slateGray} />}
                    onClick={(e) => handleAddEditDetails(e, record)}
                  />
                </Space>
                <Space size="middle">
                  <Button
                    type="text"
                    size="medium"
                    icon={<DeleteIcon fillColor={colors.slateGray} />}
                    onClick={(e) => handleConfirmDelete(e, record)}
                  />
                </Space>
              </Flex>
              :
              <>-</>
            }
            </>
          );
        },
      },
    ];
    /* table column config */
    setColumns(tempTableColumns);
  }, []);
  /* initial dependencies rendering */

  const handleAddEditDetails = (e, row) => {
    dispatch(
      Actions.createAction(Actions.SELECTED_PACKAGE_ID, {
        selectedPackageId: "",
      })
    );
    navigate(baseRouteMaker(routes.CREATE_PACKAGE));
    if (
      row?._id &&
      row?._id !== "" &&
      row?._id !== null &&
      row?._id !== undefined
    ) {
      const selectedPackageId = row?._id;
      dispatch(
        Actions.createAction(Actions.SELECTED_PACKAGE_ID, { selectedPackageId })
      );
    }
  };

  const handleConfirmDelete = (e, row) => {
    dispatch(
      Actions.createAction(Actions.SELECTED_PACKAGE_ID, {
        selectedPackageId: "",
      })
    );
    setOpenServiceDeleteDialog(true);
    if (
      row?._id &&
      row?._id !== "" &&
      row?._id !== null &&
      row?._id !== undefined
    ) {
      const selectedPackageId = row?._id;
      dispatch(
        Actions.createAction(Actions.SELECTED_PACKAGE_ID, { selectedPackageId })
      );
    }
  };

  const handleAddSponsorship = (e, row) => {
    dispatch(
      Actions.createAction(Actions.SELECTED_PACKAGE_ID, {
        selectedPackageId: "",
      })
    );
    setOpenSponsorshipDialog(true);
    if (
      row?._id &&
      row?._id !== "" &&
      row?._id !== null &&
      row?._id !== undefined
    ) {
      const selectedPackageId = row?._id;
      dispatch(
        Actions.createAction(Actions.SELECTED_PACKAGE_ID, { selectedPackageId })
      );
    }
  };

  const isOrgVerified = useSelector(
    (state) => state?.auth?.loginDetails?.organization_id?.organization_verified
  );

  const openVerificationDialog = () => {
    dispatch(Actions.createAction(Actions.VERIFIED_DIALOG_OPEN));
  };

  return (
    <div className="packageListContainer">
      <Flex vertical gap="2rem">
        <Flex align="center" justify="space-between">
          <Card
                  bordered
                  hoverable
                  style={{
                    width: 300,
                    padding: 0,
                    borderRadius: 20,
                    border: `1px solid ${colors.oceanBlue}`,
                  }}
                >
              <Row gutter={[24, 24]} align="middle" justify="center">
                <Col span={6}>
                  <Button
                    type="primary"
                    shape="circle"
                    size="middle"
                    icon={<DropboxOutlined style={{ fontSize: 22 }} />}
                    style={{ background: colors.oceanBlue }}
                  />
                </Col>
                <Col span={18}>
                  <Flex vertical>
                    <Typography.Title level={3}>
                      {t("Modules.Ads.packages")}
                    </Typography.Title>
                    <Typography.Title
                      level={2}
                      style={{ margin: 0, color: colors.DarkMint }}
                    >
                      {`${packages?.total || 0}`}
                    </Typography.Title>
                  </Flex>
                </Col>
              </Row>
            </Card>

          <Button
            type="primary"
            onClick={(e) =>
              isOrgVerified
                ? handleAddEditDetails(e, null)
                : openVerificationDialog()
            }
          >
            {t("Modules.Packages.PackagesForm.addPackage")}
          </Button>
        </Flex>
        {loading ? (
          <Spinner />
        ) : (
          <Table
            dataSource={packages?.data}
            columns={columns}
            pagination={paginationObj}
          />
        )}
      </Flex>
      <PackageDeleteDialog
        open={openServiceDeleteDialog}
        onClose={() => {
          setOpenServiceDeleteDialog(false);
          handleGetTableData();
        }}
      />
      <PackageSponsorshipFormDialog
        open={openSponsorshipDialog}
        onClose={() => {
          setOpenSponsorshipDialog(false);
          handleGetTableData();
        }}
      />
    </div>
  );
};

export default PackageList;
